import React, { useEffect } from "react";
import { useHistory } from "react-router";
import { Button, Table, Pagination } from "antd";
import { useModel } from "../../../models";
import moment from "moment";
import { DICT_KEY, getDictNameByCode, getModel, setModel, ENV } from "../../../utils/constants";
import { YhAuth } from "../../../components/Auth";
import { ResourceAuthEnum } from "../../../utils/resourcesAuth";

const columns = [
    {
        title: '序号',
        width: 50,
        // render: (_, __, index) => <span>{index + 1}</span>,
        render: (value, row, index) => {
            return {
                children: row.index,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },

    {
        title: '结算日期',
        width: 120,
        dataIndex: 'settlementDate',
        render: (value, row, index) => {
            return {
                children: value ? moment(value).format("YYYY-MM-DD") : "",
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '销售金额合计',
        width: 120,
        dataIndex: 'total',
        align: 'left',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '客户名称',
        width: 250,
        dataIndex: 'customerName',
        render: (value, row, index) => {
            return {
                children: value,
                props: {
                    rowSpan: row.rowSpanNum
                },
            };
        }
    },
    {
        title: '商品编号',
        width: 120,
        dataIndex: 'materialCode',
    },
    {
        title: '商品名称',
        width: 120,
        dataIndex: 'materialName',
    },

    {
        title: '销售价',
        width: 100,
        dataIndex: 'salePrice',
    },
    {
        title: '销售数量',
        width: 100,
        dataIndex: 'saleNum',
    },
    {
        title: '销售金额',
        width: 100,
        dataIndex: 'aggregateAmount',
    },
    {
        title: '销售类型',
        width: 100,
        dataIndex: 'orderTypeName',
    },
    {
        title: '发票类型',
        width: 100,
        dataIndex: 'invoiceTypeName',
    },
    {
        title: '成本价(按进价)',
        width: 140,
        dataIndex: 'costPrice',
        render: (value, row, index) => (<span className={value !== row.price ? "color-red" : ""}>{value}</span>)
    },
    {
        title: '销售成本(按进价)',
        width: 140,
        dataIndex: 'saleCost',
    },
    {
        title: '销售毛利(按进价)',
        width: 140,
        dataIndex: 'saleProfit',
    },
];


export default function () {
    const [
        { searchParam, customerSaleList, documentStatistic, partDealListSelectedRowKeys, searcnPage },
        { loadListDetail, setPartDealListSelectedRowKeys, exportPartDealList }
    ] = useModel("customerSaleModel");

    useEffect(() => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { customerName } = searchParam;
        let data = {
            startTime,
            endTime,
            pageSize,
            pageNum,
            customerName,
        }
        loadListDetail({ showMsg: true, data })
    }, []);

    const history = useHistory();

    const onExport = () => {
        const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
        const { pageSize, pageNum } = searcnPage
        const { customerName } = searchParam;
        let data = {
            startTime,
            endTime,
            customerName: getDictNameByCode(DICT_KEY.CM_DICT.CUSTOMER, customerName),
            pageSize,
            pageNum,
        }
        exportPartDealList({ showMsg: true, data });
    }

    const TableHeader = () => {
        return (
            <div style={{ margin: "0 0 8px", display: "flex" }}>
                <div style={{ width: "460px", paddingTop: "6px" }}>
                    <YhAuth resCode={ResourceAuthEnum.STTICS_S_EX}>
                        <Button className="margin-left-8" onClick={onExport}>导出</Button>
                    </YhAuth>
                </div>
                <div className="detail-list-statistic color-primary" style={{ textAlign: "right" }}>
                    <span
                        className="margin-left-16">
                        销售总金额：{!!documentStatistic ? documentStatistic.aggregateAmountTotal : 0.00}
                    </span>
                    <span
                        className="margin-left-16">
                        总销量：{!!documentStatistic ? documentStatistic.saleNumTotal : 0}
                    </span>
                </div>
            </div>
        )
    }
    return (
        <>
            <TableHeader />
            <Table
                columns={columns}
                dataSource={customerSaleList}
                bordered
                pagination={false}
                // pagination={{
                //     hideOnSinglePage: false,
                //     showSizeChanger: true,
                //     pageSizeOptions: [15, 50, 100, 200, 500],
                //     defaultCurrent: 1,
                //     defaultPageSize: 15,
                //     pageSize: searcnPage.lineSize,
                //     onChange: (pageNum, pageSize) => {
                //         const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                //         const { customerName } = searchParam;
                //         const data = { customerName,startTime, endTime, pageNum, pageSize }
                //         loadListDetail({ showMsg: false, data });
                //     },
                //     total: searcnPage.total,
                //     current: searcnPage.pageNum,
                // }}
                // onRow={record => {
                //     return {
                //         onClick: event => {
                //             if (partDealListSelectedRowKeys
                //                 && partDealListSelectedRowKeys[0]
                //                 && partDealListSelectedRowKeys[0] === record.key) {
                //                 setPartDealListSelectedRowKeys([]);
                //             } else {
                //                 setPartDealListSelectedRowKeys([record.key]);
                //             }
                //         },
                //     };
                // }}
                // rowSelection={{
                //     type: "radio",
                //     onChange: (selectedRowKeys) => {
                //         setPartDealListSelectedRowKeys(selectedRowKeys)
                //     },
                //     selectedRowKeys: partDealListSelectedRowKeys
                // }}
                scroll={{ x: 'max-content', y: 580 }}
            />
            <Pagination
                style={{ marginTop: '10px', textAlign: 'right' }}
                showSizeChanger
                hideOnSinglePage={false}
                pageSizeOptions={[15, 50, 100, 200, 500]}
                defaultCurrent={1}
                defaultPageSize={15}
                onChange={(pageNum, pageSize) => {
                    const [startTime = null, endTime = null] = !!searchParam["checkTime"] ? searchParam["checkTime"] : [];
                    const { supplierName } = searchParam;
                    const data = { supplierName, startTime, endTime, pageNum, pageSize }
                    loadListDetail({ showMsg: false, data });
                }}
                total={searcnPage.total}
                current={searcnPage.pageNum}
            />
        </>
    );
}